module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 297.2f7b1995.svg";